import { Pipe, PipeTransform } from '@angular/core';
import { formatNumber } from '@angular/common';

@Pipe({
  name: 'energyFormat',
  standalone: true,
})
export class EnergyFormatPipe implements PipeTransform {
  transform(value: number | undefined | null, locale?: string): string {
    if (value === undefined || value === null) {
      return '';
    }
    try {
      return formatNumber(value, locale || 'en-US', '1.0-0');
    } catch (error) {
      return formatNumber(value, 'en-US', '1.0-0');
    }
  }
}
